import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../context';
import { withRouter, NavLink } from 'react-router-dom';
import { Nav, NavItem, TabContent, TabPane, Row, Col } from "reactstrap";
import classnames from "classnames";
import { asyncHandler, updateLocalValue } from '../../utils';

import AppLayout from '../../components/AppLayout';

import Updates from '../../components/dev/Updates';
import WebcamCapture from '../../components/dev/WebcamCapture';
import BlobFiles from '../../components/dev/BlobFiles';
import FormRecognize from '../../components/dev/FormRecognize';
import DragDrop from '../../components/dev/DragDrop';
import CargoSprintApi from '../../components/dev/CargoSprintApi';
import CsApi from '../../components/dev/csApi';
import Location from '../../components/dev/Location';
import AccessRecord from '../../components/dev/AccessRecord';
import ManageCache from '../../components/dev/manageCache';
import _ from 'lodash';
import Log from '../../components/dev/log';
import ManageChangeLog from '../../components/ManageChangeLog';
import WorkItems from '../../components/dev/workItems';
import JsonToCsvConverter from '../../components/dev/jsonToCsv';
import DockDoors from './dockDoors';
import ManageDevices from './ManageDevices';
import SprintPass from './SprintPass';
import ManageApps from './ManageApps';
import ImportCalcs from './ImportCalcs';
import ShiftGrid from './Shifts';
import ManageShifts from './ManageShifts';
import EmployeeSLA from './EmployeeSLA';
import ManageUnitIp from './ManageUnitIp';
import Inventory from './Inventory';
import AI from './AI';
import UnitedGetAwb from './UnitedGetAwb';
import ManageFlights from './ManageFlights';
import ManageEnvironment from './ManageEnvironment';
import SystemStatus from '../../components/SystemStatus';
import Docusign from './Docusign';
import InventoryDemo from './Inventory/InventoryDemo';
import ActivityView from './Inventory/ActivityView';


const DevMain = () => {

    const { user, setLoading } = useContext(AppContext);

    const [activeTab, setActiveTab] = useState('manageFlights');

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <AppLayout>
            <div className={`card queue-card-container`} style={{ height: 'calc(100vh - 120px)', overflowY: 'scroll', overflowX: 'hidden' }}>
                <div className="card-body mb-5 px-1 py-1">
                    <Row className='px-3 py-3'>
                        <Col md='12' lg='12'>
                            <div style={{ display: 'flex', alignItems: 'baseline' }}>
                                <h1 className='pl-3'>DEV</h1>
                                <SystemStatus dev />
                            </div>

                            <Row className='mt-2'>
                                <Col mg='12' lg='12'>
                                    <Nav tabs className="separator-tabs ml-0 mb-2">
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "manageFlights",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("manageFlights");
                                                }}
                                            >
                                                Manage Flights
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "docusign",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("docusign");
                                                }}
                                            >
                                                DocuSign
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "ai",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("ai");
                                                }}
                                            >
                                                Queue AI Agent
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "unitedGetAwb",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("unitedGetAwb");
                                                }}
                                            >
                                                United Get Awb
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "inventory",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("inventory");
                                                }}
                                            >
                                                Inventory
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "activity",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("activity");
                                                }}
                                            >
                                                Activity
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "shifts",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("shifts");
                                                }}
                                            >
                                                Shifts
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "empSla",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("empSla");
                                                }}
                                            >
                                                Emp. SLA
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "dockDoors",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("dockDoors");
                                                }}
                                            >
                                                Dock Doors
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "manageUnitIp",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("manageUnitIp");
                                                }}
                                            >
                                                Manage Unit IPs
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "manageDevices",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("manageDevices");
                                                }}
                                            >
                                                Manage Devices
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "manageApps",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("manageApps");
                                                }}
                                            >
                                                Manage Apps
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "importCalcs",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("importCalcs");
                                                }}
                                            >
                                                Import Calcs
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "SprintPass API",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("sprintpass");
                                                }}
                                            >
                                                SprintPass API
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "logs",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("logs");
                                                }}
                                            >
                                                Logs
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "changeLog",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("changeLog");
                                                }}
                                            >
                                                Change Log
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "jsonToCsv",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("jsonToCsv");
                                                }}
                                            >
                                                JSON to CSV
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "accessRecord",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("accessRecord");
                                                }}
                                            >
                                                Access Record
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "manageCache",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("manageCache");
                                                }}
                                            >
                                                Manage Cache
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "-7",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("-7");
                                                }}
                                            >
                                                Location
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "-6",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("-6");
                                                }}
                                            >
                                                CS API
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "-2",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("-2");
                                                }}
                                            >
                                                CargoSprint Payment JSON
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "1",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("1");
                                                }}
                                            >
                                                Updates
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "2",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("2");
                                                }}
                                            >
                                                Webcam Capture
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "4",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("4");
                                                }}
                                            >
                                                Form Recognize
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeTab === "6",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("6");
                                                }}
                                            >
                                                Drag Drop
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </Col>
                            </Row>

                            <TabContent activeTab={activeTab} className='mt-2'>
                                <TabPane tabId={'manageFlights'}>
                                    <ManageFlights />
                                </TabPane>
                                <TabPane tabId={'docusign'}>
                                    <Docusign />
                                </TabPane>
                                <TabPane tabId={'ai'}>
                                    <AI />
                                </TabPane>
                                <TabPane tabId={'unitedGetAwb'}>
                                    <UnitedGetAwb />
                                </TabPane>
                                <TabPane tabId={'inventory'}>
                                    {/* <Inventory /> */}
                                    <InventoryDemo />
                                </TabPane>
                                <TabPane tabId={'activity'}>
                                    <ActivityView />
                                </TabPane>
                                <TabPane tabId={'shifts'}>
                                    {/* <ShiftGrid /> */}
                                    <ManageShifts activeTab={activeTab} />
                                </TabPane>
                                <TabPane tabId={'empSla'}>
                                    <EmployeeSLA />
                                </TabPane>
                                <TabPane tabId={'-9'}>
                                    <h1>Landing</h1>
                                    <WorkItems />
                                </TabPane>
                                <TabPane tabId={'dockDoors'}>
                                    <DockDoors 
                                        activeTab={activeTab}
                                    />
                                </TabPane>
                                <TabPane tabId={'manageUnitIp'}>
                                    <ManageUnitIp activeTab={activeTab} />
                                </TabPane>
                                <TabPane tabId={'manageDevices'}>
                                    <ManageDevices 
                                         activeTab={activeTab}
                                    />
                                </TabPane>
                                <TabPane tabId={'manageApps'}>
                                    <ManageApps activeTab={activeTab} />
                                </TabPane>
                                <TabPane tabId={'importCalcs'}>
                                    <ImportCalcs activeTab={activeTab} />
                                </TabPane>
                                <TabPane tabId={'sprintpass'}>
                                    <SprintPass activeTab={activeTab} />
                                </TabPane>
                                <TabPane tabId={'logs'}>
                                    <Log activeTab={activeTab} />
                                </TabPane>
                                <TabPane tabId={'changeLog'}>
                                    <ManageChangeLog activeTab={activeTab} />
                                </TabPane>
                                <TabPane tabId={'jsonToCsv'}>
                                    <JsonToCsvConverter />
                                </TabPane>
                                <TabPane tabId={'manageCache'}>
                                    <ManageCache />
                                </TabPane>
                                <TabPane tabId={'accessRecord'}>
                                    <AccessRecord activeTab={activeTab} />
                                </TabPane>
                                <TabPane tabId={'-7'}>
                                    <Location />
                                </TabPane>
                                <TabPane tabId={'-6'}>
                                    <CsApi
                                        tabId={activeTab}
                                    />
                                </TabPane>
                                <TabPane tabId="-2">
                                    <CargoSprintApi />
                                </TabPane>
                                <TabPane tabId="1">
                                    <Updates
                                        asyncHandler={asyncHandler}
                                        updateLocalValue={updateLocalValue}
                                        user={user}
                                        tabId={activeTab}
                                    />
                                </TabPane>
                                <TabPane tabId="2">
                                    <WebcamCapture
                                        asyncHandler={asyncHandler}
                                        updateLocalValue={updateLocalValue}
                                        user={user}
                                    />
                                </TabPane>
                                <TabPane tabId='blobFiles'>
                                    <BlobFiles
                                        asyncHandler={asyncHandler}
                                        updateLocalValue={updateLocalValue}
                                        user={user}
                                        activeTab={activeTab}
                                        setLoading={setLoading}
                                    />
                                </TabPane>
                                <TabPane tabId='4'>
                                    <FormRecognize
                                        asyncHandler={asyncHandler}
                                        updateLocalValue={updateLocalValue}
                                        user={user}
                                        activeTab={activeTab}
                                    />
                                </TabPane>
                                <TabPane tabId='6'>
                                    <DragDrop
                                        asyncHandler={asyncHandler}
                                        user={user}
                                    />
                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>
                </div>
            </div >


        </AppLayout >
    );
}

export default withRouter(DevMain);